import { Select, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { EmptyDataPane } from "./nodes/node";

export const SelectionMode = {
  SINGLE: "single",
  MULTIPLE: "multiple",
};

const SelectField = ({
  options,
  onSelectOptionChange,
  placeholder = "Select condition...",
  defaultValue,
  maxCount = 5,
  value = null,
  style = { width: "60%" },
  mode = SelectionMode.MULTIPLE,
}) => {
  const suffix = (
    <>
      {mode === SelectionMode.MULTIPLE ? (
        <span style={{ marginRight: 4 }}>
          {value?.length ?? 0} / {maxCount}
        </span>
      ) : null}
      <DownOutlined />
    </>
  );

  return (
    <Select
      mode={mode}
      style={style}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onChange={onSelectOptionChange}
      options={options}
      maxCount={maxCount}
      showSearch
      value={value}
      maxTagCount="responsive"
      suffixIcon={suffix}
      optionLabelProp="label"
      notFoundContent={
        <EmptyDataPane textMessage="No condition(s) match provided filter criteria" />
      }
      filterOption={(input, option) =>
        option?.label?.toLowerCase().includes(input.toLowerCase()) ||
        option?.desc?.toLowerCase().includes(input.toLowerCase())
      }
      optionRender={(option) => (
        <Space key={option.value}>
          {option.data?.emoji && (
            <span role="img" aria-label={option.data.label}>
              {option.data.emoji}
            </span>
          )}
          <span>{option.data?.desc ?? option.data?.label}</span>
        </Space>
      )}
    />
  );
};

export default SelectField;
